import styled from 'styled-components';

import {colors} from 'styles';

export const Container = styled.div`
  color: ${colors.secondary};
  font-size: 13px;
  line-height: 1.5;
  padding: 16px;
  text-align: center;
`;
